import { MarketEnum } from '@/config/tenants/types'
import { SiteContextModeEnum } from '@/enums/SiteContextModeEnum'
import { CountryMarketEnum } from '@/gen/bff'
import { isB2B } from '@/helpers/isB2B'

export const getMarket = (
  tenantId: string,
  siteContext: SiteContextModeEnum = SiteContextModeEnum.b2b
): CountryMarketEnum => {
  switch (tenantId) {
    case MarketEnum.mediq_dk:
      return isB2B(siteContext) ? CountryMarketEnum.DK_B2B : CountryMarketEnum.DK_B2C
    case MarketEnum.mediq_no:
      return isB2B(siteContext) ? CountryMarketEnum.NO_B2B : CountryMarketEnum.NO_B2C
    case MarketEnum.mediq_fi:
      return isB2B(siteContext) ? CountryMarketEnum.FI_B2B : CountryMarketEnum.FI_B2C
    case MarketEnum.mediq_se:
      return isB2B(siteContext) ? CountryMarketEnum.SE_B2B : CountryMarketEnum.SE_B2C
    default:
      return CountryMarketEnum.DK_B2B
  }
}
